import {IngredientDataHandler} from "../IngredientDataHandler";
import {RecipeDataHandler} from "../RecipeDataHandler";
import {FileHandler} from "../../reusable/FileHandler";

export class DataPorter {
    public static export() {
        return Promise.all([IngredientDataHandler.getIngredients(), RecipeDataHandler.getRecipes()]).then(values => {
            const ingredients = values[0] as Ingredient[]
            const recipes = values[1] as Recipe[]
            const data = {ingredients, recipes}
            new FileHandler().createAndDownloadFile([JSON.stringify(data, null, 2)], {type: "application/json", name: "recipeData.json"})
        })
    }

    public static importFile(file: File) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            const listenerSuccess = (e: any) => {
                resolve(JSON.parse(e.target.result))
            }
            const listenerError = (e: any) => {
                console.log("Error")
                reject()
            }
            reader.addEventListener("load", listenerSuccess)
            reader.addEventListener("error", listenerError)
            reader.readAsText(file)
        })
    }
}
